const WORKSPACE_PATH_REGEX = /\/w\/([a-zA-Z0-9-_]+)/;
const SITE_PATH_REGEX = /\/s\/([^\/]+)/;

const getWorkspaceIdFromPath = (): string | undefined => {
	const path = window.location.pathname;
	const workspaceId = path?.match(WORKSPACE_PATH_REGEX)?.[1];
	return workspaceId;
};

const getSiteIdFromPath = (): string | undefined => {
	const path = window.location.pathname;
	const siteId = path?.match(SITE_PATH_REGEX)?.[1];
	return siteId;
};

export interface URLContext {
	siteId?: string;
	workspaceId?: string;
}

/**
 * Inspects the current URL and extracts IDs.
 * Scenario can be derived from presence of workspaceId or siteId.
 *
 * @returns URLContext with extracted siteId/workspaceId
 */
export const extractWorkspaceOrSiteIdFromPath = (): URLContext => {
	const workspaceId = getWorkspaceIdFromPath();
	const siteId = getSiteIdFromPath();

	return {
		workspaceId,
		siteId,
	};
};
